/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  SuccessResponseDTOListEffectPackCandidateDTO,
  SuccessResponseDTOVoid,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Upload a rendered review thumbnail (PNG) for a candidate.
 */
export const uploadEffectPackThumbnail = (
  id: string,
  uploadEffectPackThumbnailBody: string,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/effect-packs/thumbnails/${id}`,
    method: 'POST',
    headers: { 'Content-Type': 'image/png' },
    data: uploadEffectPackThumbnailBody,
    ...(signal ? { signal } : {}),
  });
};

export const getUploadEffectPackThumbnailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadEffectPackThumbnail>>,
    TError,
    { id: string; data: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadEffectPackThumbnail>>,
  TError,
  { id: string; data: string },
  TContext
> => {
  const mutationKey = ['uploadEffectPackThumbnail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadEffectPackThumbnail>>,
    { id: string; data: string }
  > = (props) => {
    const { id, data } = props ?? {};

    return uploadEffectPackThumbnail(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadEffectPackThumbnailMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadEffectPackThumbnail>>
>;
export type UploadEffectPackThumbnailMutationBody = string;
export type UploadEffectPackThumbnailMutationError = unknown;

/**
 * @summary Upload a rendered review thumbnail (PNG) for a candidate.
 */
export const useUploadEffectPackThumbnail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadEffectPackThumbnail>>,
      TError,
      { id: string; data: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadEffectPackThumbnail>>,
  TError,
  { id: string; data: string },
  TContext
> => {
  const mutationOptions = getUploadEffectPackThumbnailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Candidates awaiting review (flattened per-template for the UI).
 */
export const listEffectPackCandidates = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListEffectPackCandidateDTO>({
    url: `/admin/api/effect-packs/candidates`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getListEffectPackCandidatesQueryKey = () => {
  return [`/admin/api/effect-packs/candidates`] as const;
};

export const getListEffectPackCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listEffectPackCandidates>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listEffectPackCandidates>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEffectPackCandidatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEffectPackCandidates>>> = ({
    signal,
  }) => listEffectPackCandidates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEffectPackCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListEffectPackCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEffectPackCandidates>>
>;
export type ListEffectPackCandidatesQueryError = unknown;

export function useListEffectPackCandidates<
  TData = Awaited<ReturnType<typeof listEffectPackCandidates>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEffectPackCandidates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEffectPackCandidates>>,
          TError,
          Awaited<ReturnType<typeof listEffectPackCandidates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEffectPackCandidates<
  TData = Awaited<ReturnType<typeof listEffectPackCandidates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEffectPackCandidates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEffectPackCandidates>>,
          TError,
          Awaited<ReturnType<typeof listEffectPackCandidates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEffectPackCandidates<
  TData = Awaited<ReturnType<typeof listEffectPackCandidates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEffectPackCandidates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Candidates awaiting review (flattened per-template for the UI).
 */

export function useListEffectPackCandidates<
  TData = Awaited<ReturnType<typeof listEffectPackCandidates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEffectPackCandidates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListEffectPackCandidatesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Offline pipeline pushes a candidate pack (text + effect templates) into STAGING.
 */
export const addEffectPackCandidates = (
  addEffectPackCandidatesBody: string,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/effect-packs/candidates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addEffectPackCandidatesBody,
    ...(signal ? { signal } : {}),
  });
};

export const getAddEffectPackCandidatesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addEffectPackCandidates>>,
    TError,
    { data: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addEffectPackCandidates>>,
  TError,
  { data: string },
  TContext
> => {
  const mutationKey = ['addEffectPackCandidates'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addEffectPackCandidates>>,
    { data: string }
  > = (props) => {
    const { data } = props ?? {};

    return addEffectPackCandidates(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddEffectPackCandidatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof addEffectPackCandidates>>
>;
export type AddEffectPackCandidatesMutationBody = string;
export type AddEffectPackCandidatesMutationError = unknown;

/**
 * @summary Offline pipeline pushes a candidate pack (text + effect templates) into STAGING.
 */
export const useAddEffectPackCandidates = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addEffectPackCandidates>>,
      TError,
      { data: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addEffectPackCandidates>>,
  TError,
  { data: string },
  TContext
> => {
  const mutationOptions = getAddEffectPackCandidatesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reject: drops the candidate from STAGING.
 */
export const rejectEffectPack = (id: string) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/effect-packs/candidates/${id}/reject`,
    method: 'PATCH',
  });
};

export const getRejectEffectPackMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectEffectPack>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectEffectPack>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['rejectEffectPack'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectEffectPack>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return rejectEffectPack(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectEffectPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectEffectPack>>
>;

export type RejectEffectPackMutationError = unknown;

/**
 * @summary Reject: drops the candidate from STAGING.
 */
export const useRejectEffectPack = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectEffectPack>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectEffectPack>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getRejectEffectPackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Approve: moves the template from STAGING to the published pack.
 */
export const approveEffectPack = (id: string) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/effect-packs/candidates/${id}/approve`,
    method: 'PATCH',
  });
};

export const getApproveEffectPackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveEffectPack>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveEffectPack>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['approveEffectPack'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveEffectPack>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return approveEffectPack(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveEffectPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveEffectPack>>
>;

export type ApproveEffectPackMutationError = unknown;

/**
 * @summary Approve: moves the template from STAGING to the published pack.
 */
export const useApproveEffectPack = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveEffectPack>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveEffectPack>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getApproveEffectPackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Serve a candidate's review thumbnail.
 */
export const getEffectPackThumbnail = (id: string, signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/admin/api/effect-packs/thumbnails/${id}.png`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetEffectPackThumbnailQueryKey = (id?: string) => {
  return [`/admin/api/effect-packs/thumbnails/${id}.png`] as const;
};

export const getGetEffectPackThumbnailQueryOptions = <
  TData = Awaited<ReturnType<typeof getEffectPackThumbnail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackThumbnail>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEffectPackThumbnailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEffectPackThumbnail>>> = ({ signal }) =>
    getEffectPackThumbnail(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEffectPackThumbnail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEffectPackThumbnailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEffectPackThumbnail>>
>;
export type GetEffectPackThumbnailQueryError = unknown;

export function useGetEffectPackThumbnail<
  TData = Awaited<ReturnType<typeof getEffectPackThumbnail>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackThumbnail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEffectPackThumbnail>>,
          TError,
          Awaited<ReturnType<typeof getEffectPackThumbnail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEffectPackThumbnail<
  TData = Awaited<ReturnType<typeof getEffectPackThumbnail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackThumbnail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEffectPackThumbnail>>,
          TError,
          Awaited<ReturnType<typeof getEffectPackThumbnail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEffectPackThumbnail<
  TData = Awaited<ReturnType<typeof getEffectPackThumbnail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackThumbnail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Serve a candidate's review thumbnail.
 */

export function useGetEffectPackThumbnail<
  TData = Awaited<ReturnType<typeof getEffectPackThumbnail>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackThumbnail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEffectPackThumbnailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Raw STAGING pack JSON.
 */
export const getEffectPackStaging = (signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/admin/api/effect-packs/staging`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetEffectPackStagingQueryKey = () => {
  return [`/admin/api/effect-packs/staging`] as const;
};

export const getGetEffectPackStagingQueryOptions = <
  TData = Awaited<ReturnType<typeof getEffectPackStaging>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEffectPackStaging>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEffectPackStagingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEffectPackStaging>>> = ({ signal }) =>
    getEffectPackStaging(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEffectPackStaging>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEffectPackStagingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEffectPackStaging>>
>;
export type GetEffectPackStagingQueryError = unknown;

export function useGetEffectPackStaging<
  TData = Awaited<ReturnType<typeof getEffectPackStaging>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackStaging>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEffectPackStaging>>,
          TError,
          Awaited<ReturnType<typeof getEffectPackStaging>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEffectPackStaging<
  TData = Awaited<ReturnType<typeof getEffectPackStaging>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackStaging>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEffectPackStaging>>,
          TError,
          Awaited<ReturnType<typeof getEffectPackStaging>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEffectPackStaging<
  TData = Awaited<ReturnType<typeof getEffectPackStaging>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackStaging>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Raw STAGING pack JSON.
 */

export function useGetEffectPackStaging<
  TData = Awaited<ReturnType<typeof getEffectPackStaging>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEffectPackStaging>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEffectPackStagingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
